import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import Button from 'react-bootstrap/lib/Button';

import { StationTypes } from '../../constants/AppConstants';
import { translate as t } from '../../lib/I18n';
import Station from '../../records/Station';
import Search from '../../records/Search';
import SeasonSearch from '../../records/SeasonSearch';

import Icon from '../general/Icon';
import ViaAvoidModal from './ViaAvoidModal';
import PureRenderComponent from '../PureRenderComponent';


class ViaAvoid extends PureRenderComponent {

    static propTypes = {
        season: PropTypes.bool,
        search: PropTypes.oneOfType([
            PropTypes.instanceOf(Search),
            PropTypes.instanceOf(SeasonSearch)
        ]).isRequired,
        onChange: PropTypes.func,
        errorLabel: PropTypes.node
    };

    static defaultProps = {
        season: false,
        onChange: _.noop,
        errorLabel: null
    };

    state = {
        showVia: false
    };

    _handleViaAvoidChange = (viaAvoid, station) => {
        const current = this._getViaAvoid();
        const search = this.props.search.set(current, new Station()).set(viaAvoid, station);
        this.props.onChange(search);
        this._closeViaModal();
    };

    _handleClick = () => {
        if (!this._isSelected()) {
            this._openViaModal();
        } else {
            this._handleViaAvoidChange(this._getViaAvoid(), new Station()); // Clear both stations
        }
    };

    _openViaModal = () => {
        this.setState({ showVia: true });
    };

    _closeViaModal = () => {
        this.setState({ showVia: false });
    };

    _getViaAvoid () {
        return this.props.search.avoid.nlc ? StationTypes.AVOID : StationTypes.VIA;
    }

    _renderModal () {
        if (!this.state.showVia) {
            return null;
        }

        const { search, season } = this.props;

        return (
            <ViaAvoidModal
                search={ search }
                show={ this.state.showVia }
                season={ season }
                station={ search[this._getViaAvoid()] }
                viaAvoid={ this._getViaAvoid() }
                onCancel={ this._closeViaModal }
                onSelect={ this._handleViaAvoidChange }
            />
        );
    }

    _getButtonText () {
        if (!this._isSelected()) {
            return t('booking.journey.viaAvoid');
        }

        const viaAvoid = this._getViaAvoid();
        const params = { station: this.props.search[viaAvoid].name };
        const key = `booking.journey.${viaAvoid}Station`;
        return t(key, params);
    }

    _isSelected () {
        const { search } = this.props;
        return search.via.nlc || search.avoid.nlc;
    }

    render () {
        const { errorLabel } = this.props;
        const viaIconClasses = classnames({
            'add': !this._isSelected(),
            'close': this._isSelected()
        });

        const viaClasses = classnames('btn-sm', 'js-via-avoid', {
            'via-avoid-active': this._isSelected(),
            'via-avoid-error': errorLabel
        });

        return (
            <React.Fragment>
                <Button ref="button" bsStyle="default" className={ viaClasses } onClick={ this._handleClick }>
                    <Icon icon={ viaIconClasses } />
                    { this._getButtonText() }
                    { errorLabel }
                </Button>
                { this._renderModal() }
            </React.Fragment>
        );
    }
}

export default ViaAvoid;



// WEBPACK FOOTER //
// ./src/components/search/ViaAvoid.js